/* Product imagery is hosted off-site, so any one URL can 404 or be blocked.
   Swap a failed image for an inline placeholder instead of leaving the broken
   -image glyph, and guard against a loop if the placeholder itself fails. */
export const PLACEHOLDER_IMG =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 300 300">
      <rect width="300" height="300" fill="#f3f0ea"/>
      <text x="150" y="150" font-size="64" text-anchor="middle" dominant-baseline="central">📦</text>
    </svg>`
  );

export function handleImageError(event) {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied) return;
  img.dataset.fallbackApplied = "true";
  img.src = PLACEHOLDER_IMG;
}
